import { configureStore } from '@reduxjs/toolkit'
import { connectRouter, RouterState } from 'connected-react-router'
import compReducer, { ICompareGroupConfigurationData } from 'global/Reducer/compSlice'
import dataReducer, { IGCData } from 'global/Reducer/dataSlice'
import statusReducer, { IGroupConfigurationStatus } from 'global/Reducer/statusSlice'
import { createBrowserHistory } from 'history'
import { bcbs_groupconfigurationsnapshot } from 'model/CRM'
import { IComment } from 'model/FlexibleAttributeModel'

export const history = createBrowserHistory({ basename: "/editor" })

const store = configureStore({
  reducer: {
    router: connectRouter(history)!,
    status: statusReducer,
    data: dataReducer,
    comp: compReducer,
  },
  middleware: ((getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: { ignoredPaths: ['data.config', 'comp.leftSnap.config', 'comp.rightSnap.config', 'comp.mergeSnap.config'] },
    serializableCheck: {
      ignoredPaths: ['data.config', 'comp.leftSnap.config', 'comp.rightSnap.config', 'comp.mergeSnap.config'],
      ignoredActions: ['data/setConfig', 'comp/changeMergeSnap', 'comp/loadMergeSnap', 'comp/loadRightSnap', 'comp/loadLeftSnap', 'data/updateSnapshotData'],
    },

  }))
})

export type RootState = {
  router: RouterState<unknown>;
  status: IGroupConfigurationStatus;
  data: IGCData;
  comp: {
      snapList: bcbs_groupconfigurationsnapshot[];
      leftSnap: ICompareGroupConfigurationData;
      rightSnap: ICompareGroupConfigurationData;
      mergeSnap: ICompareGroupConfigurationData;
      commentEdit: IComment;
  };
}

export type RootDataState = Pick<RootState, 'data'>

export type AppDispatch = typeof store.dispatch

export default store;